export const getAuthUser = state => state.authUser
export const getUserInfo = state => state.userInfo
export const getOnTask = state => state.onTask